import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "types/redux";

// By id

export const createTopicSelector = (id: string) => (state: RootState) => state.entities.topics.byId[id];

// This legacy function is effectively the same as `createTopicSelector` but supports an undefined `id`.
// This makes it compatible with existing code.
export const getTopic = (id: string | undefined) => (state: RootState) =>
  id === undefined ? undefined : state.entities.topics.byId[id];

export const createTopicsSelector = (ids: string[]) =>
  createSelector(...ids.map(createTopicSelector), (...topics) => topics.filter((item) => item !== undefined));

export const createCanEditTopicSelector = (id: string) => (state: RootState) =>
  state.entities.topics.byId[id]?.can_edit ?? false;

export const createHasUnauthenticatedContentAccessSelector = (id: string) => (state: RootState) =>
  state.entities.topics.byId[id]?.has_unauthenticated_content_access ?? false;

// Following

export const getFollowedTopicsIds = (state: RootState) => state.entities.topics.following.ids;

export const getFollowedTopicsHasPossibleNextPage = (state: RootState) =>
  state.entities.topics.following.hasNextPage ?? false;

export const getFollowedTopicsIsPending = (state: RootState) => state.entities.topics.following.isPending;

export const getFollowedTopicsLimit = (state: RootState) => state.entities.topics.following.limit;

export const getFollowedTopicsOffset = (state: RootState) => state.entities.topics.following.offset;

// Highlighted ids

export const getHighlightedTopicsIds = (state: RootState) => state.entities.topics.highlightedIds;

// Machine translations off ids

export const getIsMachineTranslationsOffForTopic = (id: string) => (state: RootState) =>
  state.entities.topics.byId[id]?.isMachineTranslationsOff ?? false;

// Shared with me

export const getTopicsSharedWithMeIds = (state: RootState) => state.entities.topics.sharedWithMe.ids;

export const getSharedWithMeTopicsHasNextPage = (state: RootState) =>
  state.entities.topics.sharedWithMe.hasNextPage ?? false;

export const getSharedWithMeTopicsIsPending = (state: RootState) => state.entities.topics.sharedWithMe.isPending;
